import { useMemo } from "react";
import { useParams } from "react-router-dom";
import { useCounterparty } from "../query";

export function useCurrentCounterparty() {
  const { cpId } = useParams();
  const { data } = useCounterparty(cpId);

  return useMemo(() => {
    return data;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data?.id]);
}

export function useCurrentOrgId() {
  const data = useCurrentCounterparty();

  return useMemo(() => {
    return data?.org_id;
  }, [data?.org_id]);
}
